import { createStore } from 'vuex';
import actions from './modules/actions';
import alarms from './modules/alarms';
import capacity from './modules/capacity';
import charts from './modules/charts';
import common from './modules/common';
import company from './modules/company';
import dashboards from './modules/dashboards';
import energy_eye from './modules/energy_eye';
import enpi from './modules/enpi';
import eva from './modules/eva';
import metadata from './modules/metadata';
import meter_health_check from './modules/meter_health_check';
import metrics from './modules/metrics';
import opportunities from './modules/opportunities';
import pdf_reports from './modules/pdf_reports';
import site_plans from "./modules/site_plans";
import division_plans from "./modules/division_plans";
import corporate_plans from "./modules/corporate_plans";
import powerbi from "./modules/powerbi";

import user from './modules/user';

const store = createStore({
  modules: {
    actions,
    alarms,
    capacity,
    charts,
    common,
    company,
    dashboards,
    energy_eye,
    enpi,
    eva,
    metadata,
    meter_health_check,
    metrics,
    opportunities,
    pdf_reports,
    powerbi,
    site_plans,
    division_plans,
    corporate_plans,
    user,
  }
});

export default store;